import axios from "axios";
import {
  signalsAPI,
  anomalyRuleAPI,
  anomalyTypeAPI,
  params,
  header,
} from "../_api";
import {
  SIGNALS_REQUEST,
  FETCH_SIGNALS_SUCCESS,
  FETCH_SIGNALS_FAILURE,
  FETCH_ANOMALY_TYPE_SUCCESS,
  FETCH_ANOMALY_TYPE_FAILURE,
  ANOMALY_RULE_REQUEST,
  FETCH_ANOMALY_RULE_SUCCESS,
  CLEAR_ANOMALY_STATE,
  CLEAR_ANOMALY_RULE,
  FETCH_ANOMALY_RULE_FAILURE,
  CREATE_ANOMALY_RULE_SUCCESS,
  CREATE_ANOMALY_RULE_FAILURE,
  DELETE_ANOMALY_RULE_SUCCESS,
  DELETE_ANOMALY_RULE_FAILURE,
  PERSIST_ANOMALY_RULE_FILTER,
  DELETED_ANOMALY_RULE_ID,
  SET_TYPE_FILTERS,
  CLEAR_CURRENT_SIGNALS,
  CLEAR_TYPE_FILTERS,
} from "../_constants";
import { fetchAllAnomalyRule } from "./detailsPersistActions";
import { CLEAR_ANOMALY_SEARCH_FILTERS } from '../_constants/index';

//scoped finding signals
const anomalyRuleRequest = () => {
  return { type: ANOMALY_RULE_REQUEST };
};

const fetchSignalsRequest = (data) => {
  return { type: SIGNALS_REQUEST };
};

export const setTypeFilters = (data) => {
  return { type: SET_TYPE_FILTERS, payload: data };
};

const fetchSignalsSuccess = (data) => {
  return { type: FETCH_SIGNALS_SUCCESS, payload: data };
};

const fetchSignalsFailure = (error) => {
  return { type: FETCH_SIGNALS_FAILURE, payload: error };
};

//scoped finding signals
export const fetchSignals = (reqParam=null,cancelToken=null) => {
  return async (dispatch) => {
    dispatch(fetchSignalsRequest())
    return axios
      .get(signalsAPI, {
        ...(cancelToken?{cancelToken:cancelToken.token}:{}),
        params: {
          ...params,
          ...reqParam,
          userid: sessionStorage.getItem('userId')
        },
        headers: header,
      })
      .then((response) => {
        dispatch(fetchSignalsSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response;
        if(!error.__CANCEL__){
        dispatch(fetchSignalsFailure(errorMsg));}
      });
  };
};

const fetchAnomalyTypeSuccess = (data) => {
  return { type: FETCH_ANOMALY_TYPE_SUCCESS, payload: data };
};

const fetchAnomalyTypeFailure = (error) => {
  return { type: FETCH_ANOMALY_TYPE_FAILURE, payload: error };
};

//scoped finding Type
export const fetchAnomalyType = (machine_type,hmi_type) => {
  return async (dispatch) => {
    return axios
      .get(anomalyTypeAPI, {
        params: {
          ...params,
          machine_type:machine_type,
          hmi_type:hmi_type,
          userid: sessionStorage.getItem('userId')
        },
        headers: header,
      })
      .then((response) => {
        dispatch(fetchAnomalyTypeSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchAnomalyTypeFailure(errorMsg));
      });
  };
};

const fetchAnomalyRuleSuccess = (data) => {
  return { type: FETCH_ANOMALY_RULE_SUCCESS, payload: data };
};

const fetchAnomalyRuleFailure = (error) => {
  return { type: FETCH_ANOMALY_RULE_FAILURE, payload: error };
};

export const fetchAnomalyRule = (ruleRequestBody = {},machine_type,hmi_type) => {
  return async (dispatch) => {
    dispatch(anomalyRuleRequest())
    return axios({
      method: "get",
      url: anomalyRuleAPI,
      params: {
        ...params,
        ...ruleRequestBody,
        machine_type:machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
      // data: ruleRequestBody,
    })
      .then((response) => {
        dispatch(fetchAnomalyRuleSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchAnomalyRuleFailure(errorMsg));
      });
  };
};

const createAnomalyRuleSuccess = (data) => {
  return { type: CREATE_ANOMALY_RULE_SUCCESS, payload: data };
};
const createAnomalyRuleFailure = (error) => {
  return { type: CREATE_ANOMALY_RULE_FAILURE, payload: error };
};

export const createAnomalyRule = (body, handleCreateScopedAnomaly,machine_type, hmi_type, handleStatusOfAnomalyCreation,) => {
  return async (dispatch) => {
    return axios({
      method: "post",
      url: anomalyRuleAPI,
      params: {
        ...params,
        machine_type: machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
      data: body,
    })
      .then((response) => {
        dispatch(createAnomalyRuleSuccess(response.data));
        handleStatusOfAnomalyCreation(response.data);
        handleCreateScopedAnomaly(response.data);
      })
      .catch((error) => {
        const errorMsg = error && error.response.data.message;
        handleStatusOfAnomalyCreation(false)
        dispatch(createAnomalyRuleFailure(errorMsg));
      });
  };
};


const deleteAnomalyRuleSuccess = (data) => {
  return { type: DELETE_ANOMALY_RULE_SUCCESS, payload: data };
};
const deleteAnomalyRuleFailure = (error) => {
  return { type: DELETE_ANOMALY_RULE_FAILURE, payload: error };
};

export const deleteAnomalyRule = (anomalyRudeID,machine_type,hmi_type, handleDeleteAnomalyRule) => {
  return async (dispatch) => {
    return axios({
      method: "delete",
      url: anomalyRuleAPI + anomalyRudeID,
      params: {
        ...params,
        machine_type: machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
    })
      .then((response) => {
        dispatch(deleteAnomalyRuleSuccess(response.data)); 
        handleDeleteAnomalyRule(true)      
        dispatch(fetchAllAnomalyRule(machine_type,hmi_type));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(deleteAnomalyRuleFailure(errorMsg));
        handleDeleteAnomalyRule(false)
      });
  };
};

export const saveDeletedAnomalyRule = (id) => {
  return {type: DELETED_ANOMALY_RULE_ID,
  payload:id}
}

export const clearAnomalyState = () => {
  return { type: CLEAR_ANOMALY_STATE };
};

export const clearAnomalyRule = () => {
  return { type: CLEAR_ANOMALY_RULE };
};

export const clearAnomalySearchFilter = () => {
  return { type: CLEAR_ANOMALY_SEARCH_FILTERS };
};

export const clearCurrentSignals = () => {
  return { type: CLEAR_CURRENT_SIGNALS };
};

export const persistAnomalyRuleFilter = (filter) => {
  return {
    type: PERSIST_ANOMALY_RULE_FILTER,
    payload: filter,
  };
};

export const clearTypeFilters = () => {
  return { type: CLEAR_TYPE_FILTERS };
};